var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRemoveWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.581 19.581C19.0223 20.1397 18.1165 20.1397 17.5579 19.581L12.5 14.5231L7.44215 19.581C6.88347 20.1397 5.97768 20.1397 5.41901 19.581C4.86033 19.0223 4.86033 18.1165 5.41901 17.5579L10.4769 12.5L5.41901 7.44215C4.86033 6.88347 4.86033 5.97768 5.41901 5.41901C5.97768 4.86033 6.88347 4.86033 7.44215 5.41901L12.5 10.4769L17.5579 5.41901C18.1165 4.86033 19.0223 4.86033 19.581 5.41901C20.1397 5.97768 20.1397 6.88347 19.581 7.44215L14.5231 12.5L19.581 17.5579C20.1397 18.1165 20.1397 19.0223 19.581 19.581Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemoveWhite);
export default __webpack_public_path__ + "static/media/ic-remove-white.d0e5f3cf03191f771b176dbec1ad13e1.svg";
export { ForwardRef as ReactComponent };